import { Flex } from '@hopin-team/ui-flex';
import { getFromTheme } from '@hopin-team/ui-helper-deep-branding';
import { rem } from 'polished';
import styled, { css } from 'styled-components';

export const Container = styled(Flex)<{
  backgroundColor?: string;
  textColor?: string;
  px: number;
  height: number;
}>`
  width: min-content;
  white-space: nowrap;
  height: ${({ height }) => rem(height * 8)};
  padding-left: ${({ px }) => rem(px * 8)};
  border-radius: ${({ theme }) => getFromTheme('LINE.RADIUS_DEFAULT', theme)};

  ${({ textColor, theme }) =>
    textColor &&
    css`
      color: ${getFromTheme(textColor, theme)};

      svg {
        color: ${getFromTheme(textColor, theme)};
      }
    `}

  ${({ backgroundColor, theme }) =>
    backgroundColor &&
    css`
      background-color: ${getFromTheme(backgroundColor, theme)};
    `}

  span {
    font-size: ${rem(12)};
  }
`;

export const Indicator = styled(Flex)<{ backgroundColor?: string }>`
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: ${rem(18)};
  height: ${rem(18)};
  color: ${({ theme }) => getFromTheme('COLOR.GREY.WHITE', theme)};

  ${({ backgroundColor, theme }) =>
    backgroundColor &&
    css`
      background-color: ${getFromTheme(backgroundColor, theme)};
    `}
`;
